var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    stroke: "#808080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 7.33363V11.0003L12.8333 12.8336M2.79582 10.0836C3.00124 8.06703 3.9419 6.19662 5.43833 4.82928C6.93476 3.46193 8.88221 2.69337 10.9091 2.67022C12.936 2.64707 14.9005 3.37095 16.4278 4.70375C17.9551 6.03656 18.9382 7.88499 19.1896 9.89639C19.4411 11.9078 18.9432 13.9413 17.791 15.6091C16.6388 17.2768 14.9129 18.462 12.9427 18.9385C10.9724 19.415 8.8957 19.1495 7.10874 18.1925C5.32177 17.2356 3.94965 15.6543 3.25416 13.7503M2.79582 18.3336V13.7503H7.37916",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.f407fac8b49ca7c52cc1462bcf1b36f4.svg";
export { ForwardRef as ReactComponent };